import { supabase } from '@/lib/supabaseClient';
import { TABLE_NAMES } from '@/lib/constants';
import type { Unidad } from './unitService';
import type { Edificio } from './buildingService';

export interface Inquilino {
  id_inquilino?: string;
  id_unidad?: string;
  nombre_completo: string;
  email?: string;
  telefono?: string;
  fecha_inicio_contrato?: string;
  fecha_fin_contrato?: string;
  activo?: boolean;
  // Relaciones para mostrar en la UI
  unidad?: Unidad; // Información de la unidad asociada
  edificio_unidad?: Edificio; // Alias para la información del edificio asociado a la unidad
}

export const tenantService = {
  async getTenants() {
    const { data, error } = await supabase
      .from(TABLE_NAMES.INQUILINO)
      .select(`
        id_inquilino,
        id_unidad,
        nombre_completo,
        email,
        telefono,
        fecha_inicio_contrato,
        fecha_fin_contrato,
        activo,
        unidad:id_unidad (
          *,
          edificio_unidad:edificio!unidad_id_edificio_fkey (*)
        )
      `);
    if (error) throw error;
    return data;
  },

  async getTenantsByUnit(unitId: string) {
    const { data, error } = await supabase
      .from(TABLE_NAMES.INQUILINO)
      .select(`
        id_inquilino,
        id_unidad,
        nombre_completo,
        email,
        telefono,
        fecha_inicio_contrato,
        fecha_fin_contrato,
        activo,
        unidad:id_unidad (
          *,
          edificio_unidad:edificio!unidad_id_edificio_fkey (*)
        )
      `)
      .eq('id_unidad', unitId);
    if (error) throw error;
    return data;
  },

  async createTenant(tenant: Inquilino) {
    const { data, error } = await supabase
      .from(TABLE_NAMES.INQUILINO)
      .insert([tenant])
      .select();
    if (error) throw error;
    return data[0];
  },

  async updateTenant(id: string, updates: Partial<Inquilino>) {
    const { data, error } = await supabase
      .from(TABLE_NAMES.INQUILINO)
      .update(updates)
      .eq('id_inquilino', id)
      .select();
    if (error) throw error;
    return data[0];
  },

  async deleteTenant(id: string) {
    const { error } = await supabase
      .from(TABLE_NAMES.INQUILINO)
      .delete()
      .eq('id_inquilino', id);
    if (error) throw error;
    return true;
  },
};
